import { CalendarConfig as EoleCalendarConfig } from "@syadem/eole";
import { CalendarConfig } from "./calendarConfig";

export function parseEoleCalendarConfig(eoleConfig: EoleCalendarConfig): CalendarConfig {
  return {
    id: eoleConfig.id,
    name: eoleConfig.name,
    address: eoleConfig.address,
    phoneNumber: eoleConfig.phone_number,
    email: eoleConfig.email,
    description: eoleConfig.description,
  };
}
